import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import useStyles from '../useStyles';
import PurchaseOrderProgressPresenter from './PurchaseOrderProgressPresenter';

const PurchaseOrderAgreementBubble = () => {
  const classes = useStyles();

  return (
    <div className={classes['Chat-Message-Bubble-Prgoress-root']}>
      <div className="header">
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          발주서
        </CustomizedTypography>
      </div>
      <PurchaseOrderProgressPresenter activeStep={2} />
      <div className="contentWrapper">
        <div className="content">
          <CustomizedTypography
            variant="body1"
            fontWeight="bold"
            gutterBottoms={10}
          >
            발주서 확정
          </CustomizedTypography>
          <CustomizedTypography variant="body2" className="wordBreak">
            파트너가 발주서를 확정했습니다. 파트너가 확정한 발주서를 바탕으로
            거래를 진행합니다.
          </CustomizedTypography>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderAgreementBubble;
